import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Robotics Foundations & Mechatronics Basics",
    description:
      "Introduction to Robotics ,History evolution & future trends, Components of a robot: mechanical electrical computational, Types of robots: industrial humanoid mobile service autonomous, Understanding mechatronics integration, Robotic applications across industries",
  },
  {
    title: "Mechanical Design, Kinematics & 3D Structure Modeling",
    description:
      "Basics of mechanical engineering for robots, Links joints DOF (degrees of freedom), Forward & inverse kinematics, Designing robot structures & manipulators, Intro to CAD modeling (SolidWorks/Fusion 360)",
  },
  {
    title: "Electronics, Actuators & Embedded Control Systems",
    description:
      "Microcontrollers (Arduino ESP32 STM32), Motors: DC servo stepper & BLDC, Motor drivers relays & control circuits, Power systems & battery management, Building electronic control boards for robots",
  },
  {
    title: "Sensors, Perception & Environment Interaction",
    description:
      "Ultrasonic IR LDR touch & gas sensors, IMU accelerometer & gyroscope, Camera sensors & basic computer vision, Sensor fusion techniques, Enabling robots to sense and react",
  },
  {
    title: "Robot Programming, Automation & Control Algorithms",
    description:
      "Programming robots with Python/C/C++, PID controllers & motion control, Writing automation scripts, Path planning algorithms basics, Real-time control for robot mobility",
  },
  {
    title: "Microcontrollers, Embedded Systems & Real-Time Processing",
    description:
      "Architecture of embedded systems for robotics, Communication protocols: UART I2C SPI, RTOS basics for robotic applications, Interfacing sensors & actuators with MCUs, Building reliable embedded robotic workflows",
  },
  {
    title: "Autonomous Robotics, Navigation & Mapping",
    description:
      "Line following obstacle avoidance wall-following, SLAM (Simultaneous Localization and Mapping) basics, GPS & outdoor navigation, Robot localization & trajectory planning, Introduction to ROS (Robot Operating System)",
  },
  {
    title: "AI for Robotics: Computer Vision & Machine Learning",
    description:
      "Image processing basics with OpenCV, Object detection tracking & recognition, Integrating ML models into robots, Voice recognition & human–robot interaction, Intelligent autonomous decision-making",
  },
  {
    title: "Industrial Robotics, Automation & IoT Integration",
    description:
      "Robotic arms pick-and-place systems, PLCs & industrial automation basics, IoT-enabled robots, Factory automation & Industry 4.0 concepts, Safety standards in industrial robotics",
  },
  {
    title: "Capstone Robotics Project & Career Launchpad",
    description:
      "Build a real working robot (autonomous vehicle/robotic arm/humanoid mini robot), Design → electronics → coding → testing → deployment, Documentation & presentation of your robot, Building a robotics portfolio (GitHub + project videos), Interview prep for Robotics Engineer Automation Engineer Embedded Developer roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
